export const INSTALLMENT_FULL = 'full';
export const INSTALLMENT_INSTALL = 'install';

const template = `
<div id="sia-widget">
    <label id="sia-first-row"><input type="radio" name="installment" value="${INSTALLMENT_FULL}" checked>{{ option_full }}</label>
    <div id="sia-second-row">
        <label><input type="radio" name="installment" value="${INSTALLMENT_INSTALL}">{{ option_installment }}</label>
    </div>
    <div id="sia-tip">
        <p id="sia-tip-p"> {{ installment_tip }} </p>
        <p id="sia-initial">{{ initial_payment }}</p><br>
    </div>

</div>
`;

export default template;